<template>
    <div class="wrapper1">
        <v-head></v-head>
        <v-sidebar></v-sidebar>
        <div class="content-box" :class="{ 'content-collapse': collapse }">

            <div class="content">
                <transition name="move" mode="out-in">
                    <keep-alive :include="tagsList">
                        <router-view>


                        </router-view>
                    </keep-alive>
                </transition>
            </div>
        </div>
        <div class="footer">
            <div class="footergird">
                <div class="subfootergird">
                    <img src="../../assets/img/b1.png" class="footericon" />
                    <div>
                        <div class="girdtitle1">热门游戏 应有尽有</div>
                        <div class="girdtitle2">官方精选游戏帐号</div>
                    </div>
                </div>
                <div class="subfootergird">
                    <img src="../../assets/img/b2.png" class="footericon" />
                    <div>
                        <div class="girdtitle1">平台保障</div>
                        <div class="girdtitle2">保障交易安全</div>
                    </div>
                </div>
                <div class="subfootergird">
                    <img src="../../assets/img/b3.png" class="footericon" />
                    <div>
                        <div class="girdtitle1">专属客服</div>
                        <div class="girdtitle2">客服24小时为您服务</div>
                    </div>
                </div>
                <div class="subfootergird">
                    <img src="../../assets/img/b4.png" class="footericon" />
                    <div>
                        <div class="girdtitle1">快速成交</div>
                        <div class="girdtitle2">交易迅速 收取稳妥</div>
                    </div>
                </div>
            </div>
            <div class="footerinfo">
                <div class="footertitle"> 关于我们 | 合作伙伴 | 合作联系 | 隐私保护 | 投诉建议 | 免责声明 | 诚聘英才 | 新游合作 | 安全保障</div>
                <div class="footertitle"> 浙ICP备2024099507号-1 </div>
                <div class="footertitle">杭州奕游网络科技有限公司 版权所有</div>
            </div>

        </div>
        <el-card class="rightbox">
            <div slot="header" class="clearfix">
                <div class="rightboxtitle">快捷导航</div>
            </div>
            <div class="toolcard" @click="onToolBtn(1)">
                <img class="toolicon" src="../../assets/img/toolicon1.png" />
                <div class="tooltext">下载APP</div>
            </div>
            <div class="toolcard" @click="onToolBtn(2)">
                <img class="toolicon" src="../../assets/img/toolicon2.png" />
                <div class="tooltext">联系客服</div>
            </div>
            <div class="toolcard" @click="onToolBtn(3)">
                <img class="toolicon" src="../../assets/img/toolicon3.png" />
                <div class="tooltext">业务介绍</div>
            </div>
            <div class="toolcard" @click="onToolBtn(4)">
                <img class="toolicon" src="../../assets/img/toolicon4.png" />
                <div class="tooltext">投诉建议</div>
            </div>
            <div class="toolcard" @click="onToolBtn(5)">
                <img class="toolicon" src="../../assets/img/toolicon5.png" />
                <div class="tooltext">帮助中心</div>
            </div>
        </el-card>

    </div>
</template>

<script>
import vHead from './Header.vue';
import vSidebar from './Sidebar.vue';
import vTags from './Tags.vue';
import bus from './bus';
export default {
    name: "homes",
    metaInfo: {
        title: '1701账号交易平台-签署合同-包赔-秒打款', // set a title
        meta: [{                 // set meta
            name: '1701，1701账号，1701账号交易,盼之，7881，换号吧，螃蟹，螃蟹账号，螃蟹代售，螃蟹账号交易，螃蟹游戏服务网，螃蟹账号服务网，账号交易，游戏交易、账号交易平台，原神交易平台，王者荣耀交易平台，英雄联盟交易平台，永劫无间交易平台，穿越火线交易平台，鉴号估价，包赔平台，中介平台,盼之代售，专业正规的游戏账号交易平台，提供网游交易售卖，手游账号买号卖号服务。王者荣耀账号出售，穿越火线cf卖号交易，英雄联盟lol买号交易，原神账号交易充值等',
            content: '1701游戏账号交易代售平台是国内安全、权威、服务完善的大型网络游戏账号交易代售平台，提供游戏账号交易、手游交易、道具交易、账号买卖、鉴号估价、担保中介、账号回收、账号追回等服务，同时为用户提供专业的售后保障，找回包赔无时间限制，所有交易均签署专业电子版法律合同，让游戏账号交易有字有据，享受法律效力，保证用户权益。'
        }],
        link: [{                 // set link
            rel: 'asstes',
            href: 'https://assets-cdn.github.com/'
        }]
    },
    data() {
        return {
            tagsList: [],
            collapse: false
        }
    },
    components: {
        vHead, vSidebar, vTags
    },
    created() {
        bus.$on('collapse', msg => {
            this.collapse = msg;
        })

        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。this.$router.push(`/${key}`);
        bus.$on('tags', msg => {
            let arr = [];
            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            this.tagsList = arr;
        })
    },
    methods: {
        onToolBtn(cmd) {
            switch (cmd) {
                case 1:
                     this.$router.push(`/download`);
                    break;
                case 2:
                    this.$router.push(`/help?index=4`);
                    break;
                case 3:
                    this.$router.push(`/guide`);
                    break;
                case 4:
                    this.$router.push(`/help?index=3`);
                    break;
                case 5:
                    this.$router.push(`/help?index=4`);
                    break;
            }
        }
    }
}
</script>


<style scoped>
.footer {
    bottom: 0;
    width: 100%;
    height: 140px;
}

.footergird {
    height: 110px;
    width: 100%;
    display: flex;
    background-color: #fff;
    box-shadow: 4px 4px 4px 4px #d7d7d7;
    width: 1500px;
    padding-left: calc(50% - 750px);
    padding-right: calc(50% - 750px);
    padding-top: 10px;
}

.subfootergird {
    width: 375px;
    height: 100%;
    display: flex;

}

.footericon {
    width: 70px;
    height: 70px;
    padding: 10px;
    border-radius: 100%;
}

.girdtitle1 {
    font-size: 24px;
    color: rgb(104, 104, 104);
    line-height: 70px;
    font-weight: 400;
}

.girdtitle2 {
    font-size: 18px;
    color: rgb(179, 179, 179);
    margin-top: -20px;
}

.footerinfo {
    height: 100%;
    width: 100%;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 4px 4px 4px 4px #d7d7d7;

    padding-top: 10px;
}

.footertitle {
    color: rgb(139, 139, 139);
    text-align: center;
    line-height: 40px;
}

.rightbox {
    position: fixed;
    right: 10px;
    top: calc(50% - 230px);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 110px;
}

.el-card {
    border-radius: 20px;
}

.toolcard {
    cursor: pointer;
    margin-bottom: 20px;
}

.toolicon {
    width: 40px;
    height: 40px;
    padding: 5px;
    margin-left: calc(50% - 25px);
}

.toolicon:hover {
    width: 50px;
    height: 50px;
    padding: 0px;
    margin-left: calc(50% - 25px);
}

.tooltext {
    text-align: center;
    font-size: 16px;
    color: #616161;
}

.rightboxtitle {
    color: #ff8800;
    font-size: 16px;
}
</style>
